import { useTranslation } from "react-i18next"
import { Banner } from "@/components/ui/banner"
import { useWaitingRoomFilters } from "@/modules/waiting-room/contexts/waiting-room-filters-context"
import { checkStatusesIsCancelledOrClosed } from "@/modules/waiting-room/helpers/waiting-room-helper"

const StatusFilterWarning = () => {
  const { t } = useTranslation()
  const { filters } = useWaitingRoomFilters()

  const statusFilters = filters.statuses || []

  if (checkStatusesIsCancelledOrClosed(statusFilters) && !filters.dateRange) {
    return (
      <div className="bg-background-subdued grid h-10 gap-2 overflow-hidden px-8 transition-all duration-200">
        <Banner type="inline" variant="warning" data-testid="status-warning-banner">
          {t("scheduling.waitingRoom.statusWarning")}
        </Banner>
      </div>
    )
  }

  return null
}
export { StatusFilterWarning }
